let mixin = {
  methods: {
    /**
     * Returns a value converted from x unit to y unit
     *
     * @param {Number} value to be converted
     * @param {Number} value's unit
     * @param {Number} prefered unit size
     * @param {Boolean} if the prefered unit size must be as minimum unit or absolute unit
     */
    calcMegabytes(
      planStorage,
      valueSize = 'MB',
      preferedSize,
      isMinPreferedSize
    ) {
      if (planStorage === Infinity || planStorage === -Infinity) return false

      let sizes = ['B', 'KB', 'MB', 'GB', 'TB']
      let valueSizeIndex = sizes.indexOf(valueSize) + 1

      // Check if it has a prefered unit size
      if (preferedSize) {
        let originalPreferedSizeIndex = sizes.indexOf(preferedSize)
        let preferedSizeIndex = originalPreferedSizeIndex + 1
        let calcIndex = valueSizeIndex - preferedSizeIndex
        let finalNumber

        if (calcIndex === 0) {
          finalNumber = planStorage
        } else if (calcIndex > 0) {
          finalNumber = planStorage * Math.pow(1024, calcIndex)
        } else if (calcIndex < 0) {
          let planStorageCalc = planStorage
          while (calcIndex < 0) {
            planStorageCalc = planStorageCalc / 1024
            calcIndex++
          }
          finalNumber = planStorageCalc
        }

        if (finalNumber < 1 && planStorage > 0) {
          finalNumber = 1
        }

        if (isMinPreferedSize) {
          let to1024 = finalNumber / 1024
          if (to1024 / 1024 >= 1) {
            while (to1024 / 1024 >= 1) {
              if (originalPreferedSizeIndex + 1 <= sizes.length) {
                originalPreferedSizeIndex++
              }

              if (originalPreferedSizeIndex + 1 >= sizes.length) break
              to1024 = to1024 / 1024
            }
            finalNumber = to1024
          } else {
            if (to1024 >= 1) {
              finalNumber = to1024
              originalPreferedSizeIndex++
            }
          }
        }

        finalNumber = this.toPlainString(finalNumber)

        let numberDotIndex = String(finalNumber).indexOf('.')

        if (numberDotIndex !== -1) {
          let valueAfterDot = String(finalNumber).split('.')[1]
          if (Number(valueAfterDot[0]) > 0 || valueAfterDot.length > 1) {
            finalNumber = String(finalNumber).slice(0, numberDotIndex + 3)
            return finalNumber + ' ' + sizes[originalPreferedSizeIndex]
          } else {
            finalNumber = String(finalNumber).slice(0, numberDotIndex + 2)
            return finalNumber + ' ' + sizes[originalPreferedSizeIndex]
          }
        }

        return finalNumber + ' ' + sizes[originalPreferedSizeIndex]
      } else {
        let bytesIndex = sizes.indexOf('B') + 1
        let calcIndex = valueSizeIndex - bytesIndex
        let bytes
        let finalNumber

        if (calcIndex === 0) {
          bytes = planStorage
        } else if (calcIndex > 0) {
          bytes = planStorage * Math.pow(1024, calcIndex)
        } else if (calcIndex < 0) {
          let planStorageCalc = planStorage
          while (calcIndex < 0) {
            planStorageCalc = planStorageCalc / 1024
            calcIndex++
          }
          bytes = planStorageCalc
        }

        let i = Math.floor(Math.log(bytes) / Math.log(1024))
        if (i === -Infinity) i = 0

        let theSize = sizes[i]
        finalNumber = bytes / Math.pow(1024, i)

        if (finalNumber < 1 && bytes > 0) {
          finalNumber = 1
        }

        finalNumber = this.toPlainString(finalNumber)

        if (Number(finalNumber) === 0) return finalNumber + ' ' + theSize

        let numberDotIndex = String(finalNumber).indexOf('.')

        if (numberDotIndex !== -1) {
          let valueAfterDot = String(finalNumber).split('.')[1]

          if (Number(valueAfterDot[0]) > 0) {
            finalNumber = String(finalNumber).slice(0, numberDotIndex + 2)
            return finalNumber + ' ' + theSize
          } else {
            finalNumber = String(finalNumber).slice(0, numberDotIndex)
            return finalNumber + ' ' + theSize
          }
        } else {
          return finalNumber + ' ' + theSize
        }
      }
    },
    /**
     * It prevents Javascript rounds to values with +e or -e, like 1e6
     * @param {Number} num
     * @returns {String}
     */
    toPlainString(num) {
      return ('' + +num).replace(
        /(-?)(\d*)\.?(\d*)e([+-]\d+)/,
        function (a, b, c, d, e) {
          return e < 0
            ? b + '0.' + Array(1 - e - c.length).join(0) + c + d
            : b + c + d + Array(e - d.length + 1).join(0)
        }
      )
    },
  },
}

export default mixin
